import { Component, computed, inject, input, resource } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { firstValueFrom, map } from "rxjs";

import { TranslateTokenPipe } from "../../../../core/pipes";
import type { SelectedPeriodModelType } from "../../../models";
import { CalculationEngineApiService } from "../../../services";
import { AiPerformanceCardComponent } from "../ai-performance-card/ai-performance-card";
import { ItemSliderComponent } from "../item-slider/item-slider";

@Component({
  selector: "adaa-ai-performance",
  templateUrl: "./ai-performance.html",
  styleUrl: "./ai-performance.scss",
  imports: [TranslatePipe, TranslateTokenPipe, ItemSliderComponent, AiPerformanceCardComponent],
})
export class AiPerformanceComponent {
  private readonly _calculationEngineApiService = inject(CalculationEngineApiService);

  readonly selectedPeriod = input.required<SelectedPeriodModelType>();

  readonly performance = resource({
    params: () => this.selectedPeriod(),
    loader: ({ params }) =>
      firstValueFrom(
        this._calculationEngineApiService
          .getAIPerformance(
            params.type === "quarter" ? params.period.id : params.period.year,
            params.type === "quarter"
          )
          .pipe(map((e) => e.responseData))
      ),
  });

  readonly tracks = computed(() => this.performance.value()?.tracks ?? []);

  readonly periodLabel = computed(() => {
    const period = this.selectedPeriod();
    if (!period?.period) return "";
    return period.type === "year" ? `${period.period.year}` : `Q${period.period.quarter} ${period.period.year}`;
  });
}
